import AutosizeInput from 'react-input-autosize';
import { FieldInputProps, FieldMetaState } from 'react-final-form';

import { currencySymbols, formatNoSymbol } from 'utils/number';
import { AmountBox, CurrencySym, AmountBoxTitle } from './adapt-split-amount-field.view';

interface AdaptSplitAmountFieldProps {
  input: FieldInputProps<string>;
  bgColor: string;
  values: string;
  label: string;
  meta: FieldMetaState<string>;
}

const AdaptSplitAmountField = ({
  input,
  bgColor,
  values = '0.00',
  label,
  meta,
  ...rest
}: AdaptSplitAmountFieldProps) => {
  return (
    <AmountBox bgColor={bgColor}>
      <AmountBoxTitle>{label}</AmountBoxTitle>
      <div>
        <AutosizeInput
          {...input}
          {...rest}
          placeholder={formatNoSymbol('0.00')}
          minWidth={120}
          onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
            event?.target?.select();
            input.onFocus(event);
          }}
          inputMode="decimal"
          maxLength={12}
          autoFocus
          value={formatNoSymbol(`${values}`)}
          disabled
        />
        <CurrencySym>{currencySymbols()}</CurrencySym>
      </div>
    </AmountBox>
  );
};

export default AdaptSplitAmountField;
